import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Région } from '../model/région.model';
import { avecMéthodesRégions } from './région.methods';

export const RégionStore = signalStore({ providedIn: 'root' }, withEntities<Région>(), avecMéthodesRégions());
